import React from "react"
import { useDroppable } from "@dnd-kit/react"
import { CollisionPriority } from "@dnd-kit/abstract"
import moment from "moment"
import NavigationLink from "~/library/NavigationLink"
import type Deal from "~/types/Deal"
import DraggableDealCard from "./DraggableDealCard"

const formatMoney = (value?: number | string | null) => {
    if (value == null) return "$0.00"
    const numValue = typeof value === "string" ? parseFloat(value) : value
    return `$${numValue.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
}

interface DroppableStageSectionProps {
    stage: { id: string; name: string; colorCode: string }
    deals: Deal[]
    totalValue: number
}

const DroppableStageSection: React.FC<DroppableStageSectionProps> = ({
                                                                         stage,
                                                                         deals,
                                                                         totalValue,
                                                                     }) => {
    const { ref } = useDroppable({
        id: stage.id,
        type: "stage",
        accept: "deal",
        collisionPriority: CollisionPriority.Low,
    })

    return (
        <div className="col" style={{ minWidth: '280px' }}>
            <div className="card h-100 border-0" style={{ backgroundColor: 'transparent' }}>
                <div
                    className="card-header text-white d-flex justify-content-between align-items-center"
                    style={{
                        backgroundColor: stage.colorCode || '#6c757d',
                        minHeight: '60px'
                    }}
                >
                    <div>
                        <h6 className="mb-0">{stage.name}</h6>
                        <small className="opacity-75">{deals.length} deals</small>
                    </div>
                    <h5 className="mb-0">{formatMoney(totalValue)}</h5>
                </div>

                <div
                    ref={ref}
                    className="card-body p-2"
                    style={{
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        backgroundColor: 'transparent',
                        minHeight: '200px'
                    }}
                >
                    {deals.length > 0 ? (
                        <div>
                            {deals.map((deal, index) => (
                                <DraggableDealCard
                                    key={deal.id}
                                    deal={deal}
                                    index={index}
                                    stageId={stage.id}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="text-center text-muted py-4">
                            <small>No deals in this stage</small>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DroppableStageSection
